import { RadioButton } from 'cpool-components/input/RadioButton';
import { TextInput } from 'cpool-components/input/TextInput';

import type { ApplicantCreation } from 'cpool-schemas';
import type { Path } from 'react-hook-form';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = {
    basePath: string;
};

export const AbloesenSection: React.FC<Props> = ({ basePath }) => {
    const { t } = useTranslation();
    const { control, register } = useFormContext<ApplicantCreation>();
    const abloesen = useWatch({
        control,
        name: `${basePath}.abloesen` as Path<ApplicantCreation>,
    });

    return (
        <>
            <div className="col-span-2 flex gap-2.5 items-center">
                <span className="w-[175px] shrink-0 text-sm text-midnight text-left">
                    {t('EXISTING_LOANS.LOAN_REPLACE')}
                </span>
                <Controller
                    name={`${basePath}.abloesen` as Path<ApplicantCreation>}
                    control={control}
                    render={({ field }) => (
                        <div className="flex w-full gap-4 justify-start">
                            <RadioButton
                                showBorder
                                wrapperClassName="flex justify-center w-32"
                                id={`${basePath}.abloesen.yes`}
                                name={`${basePath}.abloesen`}
                                value="true"
                                checked={field.value === true}
                                onChange={() => field.onChange(true)}
                                label={t('VALUES.YES')}
                            />
                            <RadioButton
                                showBorder
                                wrapperClassName="flex justify-center w-32"
                                id={`${basePath}.abloesen.no`}
                                name={`${basePath}.abloesen`}
                                value="false"
                                checked={field.value === false}
                                onChange={() => field.onChange(false)}
                                label={t('VALUES.NO')}
                            />
                        </div>
                    )}
                />
            </div>

            {abloesen && (
                <>
                    <TextInput
                        id={`${basePath}.iban`}
                        label={t('EXISTING_LOANS.LOAN_IBAN')}
                        labelClassName="w-[175px] justify-start"
                        {...register(`${basePath}.iban` as Path<ApplicantCreation>)}
                    />

                    <TextInput
                        id={`${basePath}.bic`}
                        label={t('EXISTING_LOANS.LOAN_BIC')}
                        labelClassName="w-[175px] justify-start"
                        {...register(`${basePath}.bic` as Path<ApplicantCreation>)}
                    />
                </>
            )}
        </>
    );
};
